// extracted by mini-css-extract-plugin
module.exports = {"appHeader":"Nav_appHeader__He_bK","brand__logo":"Nav_brand__logo__1n_01","registerButton":"Nav_registerButton__5gFQt","brandLogo":"Nav_brandLogo__2mQLD"};